import React, { useCallback } from 'react'

import { Tabs } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, func, bool } from 'prop-types'

import { getSalesTabs, validTabs } from '../Static/constants'
import Coupons from './Sections/Coupons/Coupons'
import Discounts from './Sections/Discounts/Discounts'
import Donations from './Sections/Donations/Donations'
import Followers from './Sections/Followers'
import OverviewTab from './Sections/Overview/OverviewTab'
import PaymentsInfo from './Sections/PaymentsInfo/PaymentsInfo'
import Referrals from './Sections/Referrals'

function Sales({
  activeTab, onTabChange, showOverviewTab = false, showReferralTab = false,
  maximizeEarningsForceOptIn = false,
  isSubscriptionParticipant = false,
}) {
  const tabsComponents = {
    ...(showOverviewTab ? { [validTabs.overview]: OverviewTab } : {}),
    [validTabs.payouts]: PaymentsInfo,
    [validTabs.coupons]: Coupons,
    [validTabs.discounts]: Discounts,
    [validTabs.donations]: Donations,
    [validTabs.followers]: Followers,
    ...(showReferralTab ? { [validTabs.referrals]: Referrals } : {}),
  }

  const renderTabContent = useCallback(() => {
    const TabComponent = tabsComponents[activeTab]
    const isOverview = activeTab === validTabs.overview
    const isDiscounts = activeTab === validTabs.discounts
    const extraProps = {
      ...(isOverview ? { isSubscriptionParticipant } : {}),
      ...(isDiscounts ? { maximizeEarningsForceOptIn } : {}),
    }
    return (
      <div id="active-tab-content">
        <TabComponent {...extraProps} />
      </div>
    )
  }, [activeTab, isSubscriptionParticipant, maximizeEarningsForceOptIn])

  return (
    <div className="cgt-mt-20 my-sales-tabs-container">
      <div className="cgt-mb-20">
        <Tabs
          className="sales-tabs"
          activeTabId={activeTab}
          onClick={onTabChange}
          tabs={getSalesTabs(showOverviewTab, showReferralTab)}
        />
      </div>

      {renderTabContent()}
    </div>
  )
}

Sales.propTypes = {
  activeTab: string.isRequired,
  onTabChange: func.isRequired,
  showOverviewTab: bool,
  showReferralTab: bool,
  maximizeEarningsForceOptIn: bool,
  isSubscriptionParticipant: bool,
}

export default React.memo(Sales)
